<template>
    <div>
        <el-button size="mini" icon="el-icon-plus" @click="to_edit_company(null)">新增</el-button>
        <el-table :data="list_data.list" v-loading="loading" style="width: 100%" border>
            <el-table-column prop="company_name" label="物流公司" width="256">
              <template slot-scope="scope">
                <p>{{scope.row.company_name}}</p>
                <p>{{scope.row.company_name_en}}</p>
                <p>{{scope.row.website}}</p>
                <p>{{scope.row.city}}</p>
                <p>{{scope.row.ctime}}</p>
              </template>   
            </el-table-column>
            <el-table-column prop="accounts" label="制单账号" min-width="100">
                <template slot-scope="scope">
                  <el-table :data="scope.row.accounts" style="width: 100%" border>
                      <el-table-column prop="sender_company" label="发件公司" width="256">
                          <template slot-scope="scope2">
                            <div style="border-bottom: 1px solid #dfdfdf;margin-bottom:10px;padding-bottom: 10px;">
                                <p>开户主体: <b>{{scope2.row.sender_company}}</b></p>
                                <p>发件身份: {{scope2.row.sender_name}}</p>
                                <p>发货仓库: {{scope2.row.warehouse_name}}</p>
                                <p>制单ID: {{scope2.row.client_id}}</p>
                            </div>
                            <div>
                                <h3>发货人：</h3>
                                <p>{{scope2.row.sender_phone}}</p>
                                <p>{{scope2.row.sender_email}}</p>
                                <p>
                                    <span>{{scope2.row.sender_country}}</span>
                                    <span>,{{scope2.row.sender_state}}</span>
                                    <span>,{{scope2.row.sender_city}}</span>
                                    <span>,{{scope2.row.sender_zipcode}}</span>
                                </p>
                                <p>{{scope2.row.sender_address}}</p>
                            </div>
                          </template> 
                      </el-table-column>
                      <el-table-column prop="channels" label="启用渠道" min-width="100">
                          <template slot-scope="scope2">
                            <el-table :data="scope2.row.active_channels" style="width: 100%" border>
                                <el-table-column prop="channel_code" label="渠道" width="333">
                                    <template slot-scope="scope3">
                                        <p>渠道编码：<b>{{ scope3.row.channel_code }}</b></p>
                                        <p>渠道名称：{{ scope3.row.channel_name }}</p>
                                        <p>发货仓库：{{ scope3.row.warehouse_name_cn }}</p>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="calculator" label="运费公式" min-width="123">
                                    <template slot-scope="scope3">
                                        <el-table :data="scope3.row.offers" style="width: 100%" border>
                                            <el-table-column prop="country_code" label="国家" min-width="123">
                                                <template slot-scope="scope4">
                                                    <el-select v-model="scope4.row.country_code" placeholder="请选择国家" size="mini" filterable>
                                                        <el-option
                                                            v-for="item in $store.state.public.cfg.country_options"
                                                            :key="item.value"
                                                            :label="item.label"
                                                            :value="item.value"
                                                        ></el-option>
                                                    </el-select>
                                                    <el-select v-model="scope4.row.area_zone" placeholder="请选择区域" size="mini" clearable v-if="scope4.row.country_code">
                                                        <el-option
                                                            v-for="zone2 in $store.state.public.cfg.country_area_zone_options" 
                                                            :key="zone2.value"
                                                            :label="zone2.label"
                                                            :value="zone2.value"
                                                        ></el-option>
                                                    </el-select>
                                                </template>
                                            </el-table-column>
                                            <el-table-column prop="first_price" label="首重价" width="155">
                                                <template slot-scope="scope4">
                                                    <el-input v-model="scope4.row.first_price" style="width:133px;" size="mini" placeholder="0.00"></el-input>
                                                </template>
                                            </el-table-column>
                                            <el-table-column prop="weight_price" label="步进价" width="155">
                                                <template slot-scope="scope4">
                                                    <el-input v-model="scope4.row.weight_price" style="width:133px;" size="mini" placeholder="0.00"></el-input>
                                                </template>
                                            </el-table-column>
                                            <el-table-column prop="calc_min_weight" label="首重(g)" width="155">
                                                <template slot-scope="scope4">
                                                    <el-input v-model="scope4.row.calc_min_weight" style="width:133px;" size="mini" placeholder="0"></el-input>
                                                </template>
                                            </el-table-column>
                                            <el-table-column prop="inc_weight" label="步进重(g)" width="155">
                                                <template slot-scope="scope4">
                                                    <el-input v-model="scope4.row.inc_weight" style="width:133px;" size="mini" placeholder="0"></el-input>
                                                </template>
                                            </el-table-column>
                                            <el-table-column prop="range_weight_min" label="重量区间(g)" width="200">
                                                <template slot-scope="scope4">
                                                    <el-input v-model="scope4.row.range_weight_min" style="width:80px;" size="mini" placeholder="0"></el-input>
                                                    -
                                                    <el-input v-model="scope4.row.range_weight_max" style="width:80px;" size="mini" placeholder="0"></el-input>
                                                </template>
                                            </el-table-column>
                                            <el-table-column prop="id" label="操作" width="123">
                                                <template slot-scope="scope4">
                                                    <el-tag size="mini" type="primary" class="pointer" @click="save_offer(scope3.row, scope4.row)">保存</el-tag>
                                                    <el-tag size="mini" type="danger" class="pointer" @click="del_offer(scope3.row, scope4.row)">删除</el-tag>
                                                </template>
                                            </el-table-column>
                                        </el-table>  
                                        <div>
                                            <i class="el-icon-plus pointer" @click="add_offer(scope3.row)">one</i>
                                            <i class="el-icon-plus pointer" @click="add_all(scope3.row)" style="margin-left:10px;">all</i>
                                        </div>
                                    </template> 
                                </el-table-column>
                            </el-table>  
                          </template>                
                      </el-table-column>
                      <el-table-column prop="ctime" label="操作" width="100" align="right">
                          <template slot-scope="scope2">
                              <el-switch v-model="scope2.row.status_bool" active-color="#13ce66" inactive-color="#aaaaaa" @change="change_account_status(scope2.row)"></el-switch><br><br>
                              <el-tag size="mini" type="primary" class="pointer" @click="to_pop_channels(scope2.row.id)">渠道</el-tag><br />
                              <el-tag size="mini" type="warning" class="pointer"  @click="to_edit_account(scope.row.id, scope2.row)">编辑</el-tag><br />
                              <el-tag size="mini" type="info" class="pointer" @click="remove_account(scope2.row.id)">删除</el-tag>
                          </template>        
                      </el-table-column>
                  </el-table>  
                  <a class="pointer gray-color" @click="to_edit_account(scope.row.id, null)">+添加</a>
                </template>                
            </el-table-column>
            <el-table-column prop="ctime" label="操作" width="100" align="right">
                <template slot-scope="scope">
                    <el-switch v-model="scope.row.status_bool" active-color="#13ce66" inactive-color="#aaaaaa" @change="change_company_status(scope.row)"></el-switch><br><br>
                    <el-tag size="mini" class="pointer" @click="to_edit_company(scope.row)">编辑</el-tag><br>
                    <el-tag size="mini" type="info" class="pointer" @click="remove_company(scope.row.id)">删除</el-tag>
                </template>        
            </el-table-column>
        </el-table>    
        <component :is="popName" :item="editItem" :logistics_company_id="edit_logistics_company_id" :logistics_company_account_id="edit_logistics_company_account_id"></component>
    </div>
</template>
<script>
const pop_edit_company = resolve => require(['@/pages/logistics/setting/_pop_edit_company'], resolve);  
const pop_edit_account = resolve => require(['@/pages/logistics/setting/_pop_edit_account'], resolve);  
const pop_channels = resolve => require(['@/pages/logistics/setting/_pop_channels'], resolve);  
export default {
    components:{
      pop_edit_company,
      pop_edit_account,
      pop_channels,
    },
    data(){
      return {
        loading:false,
        popName:null,
        editItem: null,
        edit_logistics_company_id:0,
        edit_logistics_company_account_id:0,
        filter:{

        },
        list_data:{
            total:0,
            size:10,
            list:[],
        },
      }
    },
    methods:{
        to_pop_channels(id){
            this.edit_logistics_company_account_id = id
            this.popName = 'pop_channels'
        },
        to_edit_company(row = null){
            this.editItem = row
            this.popName = 'pop_edit_company'
        },
        to_edit_account(logistics_company_id, row = null){
            this.editItem = row
            this.edit_logistics_company_id = logistics_company_id
            this.popName = 'pop_edit_account'
        },
        add_offer(channel){
            if (!channel.offers) {
                this.$set(channel, 'offers', []);
            }
            var offers = channel.offers;
            offers.push({
                id:0,
                logistics_channel_auto_id:channel.id,
                country_code: "",
                area_zone: "",
                first_price: 20,
                weight_price: 1,
                inc_weight: 1,
                calc_min_weight: 1,
                range_weight_min: 1,
                range_weight_max: 2000,
            })
            this.$set(channel, 'offers', offers);
        },
        add_all(channel){
            if (!channel.offers) {
                this.$set(channel, 'offers', []);
            }
            var offers = channel.offers;
            var options = this.$store.state.public.cfg.country_options;
            for (var i=0; i<options.length; i++) {
                var exist = false;
                for (var j=0; j<offers.length; j++) {
                    if (offers[j].country_code == options[i].value) {
                        exist = true;
                        break;
                    }
                }
                if (!exist) {
                    offers.push({
                        id:0,
                        logistics_channel_auto_id:channel.id,
                        country_code: options[i].value,
                        area_zone: "",
                        first_price: 20,
                        weight_price: 1,
                        inc_weight: 1,
                        calc_min_weight: 20,
                        range_weight_min: 1,
                        range_weight_max: 2000,
                    })
                }
            }

            this.$set(channel, 'offers', offers);
        },
        save_offer(channel, offer){
          this.$http.post('/v1/pri/logistics-cfg/save-offer', offer)
          .then( (response) => {
              var res = response.data;
              if (res.code == 1) {
                  this.$message({
                      message: '保存成功',
                      type: 'success'
                  });
              } else {
                  this.$message({
                      message: res.msg,
                      type: 'warning'
                  });
              }
          })  
        },
        del_offer(channel, offer){
            if (!channel || !channel.offers) return;
            const index = channel.offers.indexOf(offer);
            if (index !== -1) {
                this.$confirm('确定要删除该条运费公式吗？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    if (offer.id > 0) {
                        this.$http.post('/v1/pri/logistics-cfg/remove-offer', {offer_id:offer.id})
                        .then( (response) => {
                            var res = response.data;
                            if (res.code == 1) {
                                channel.offers.splice(index, 1);
                                this.$message({
                                    message: '删除成功',
                                    type: 'success'
                                });
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'warning'
                                });
                            }
                        }) 
                    } else {
                        channel.offers.splice(index, 1);
                        this.$message({
                            type: 'success',
                            message: '删除成功'
                        });
                    }

                }).catch(() => {
                // 取消删除
                });
            }
        },
      change_company_status(item){
          this.$http.post('/v1/pri/logistics-cfg/set-company-status', {id:item.id, status:item.status_bool ? 1 : 0})
          .then( (response) => {
              var res = response.data;
              if (res.code == 1) {
                  this.$message({
                      message: '操作成功',
                      type: 'success'
                  });
              } else {
                  this.$message({
                      message: res.msg,
                      type: 'warning'
                  });
              }
          })             
      },
      change_account_status(item){
          this.$http.post('/v1/pri/logistics-cfg/set-company-account-status', {id:item.id, status:item.status_bool ? 1 : 0})
          .then( (response) => {
              var res = response.data;
              if (res.code == 1) {
                  this.$message({
                      message: '操作成功',
                      type: 'success'
                  });
              } else {
                  this.$message({
                      message: res.msg,
                      type: 'warning'
                  });
              }
          })             
      },
      get_company_list(){
          this.loading = true;
          this.$http.post('/v1/pri/logistics-cfg/company-list', this.filter)
          .then( (response) => {
              this.loading = false;
              var res = response.data;
              if (res.code == 1) {
                  this.list_data = res.data
              }
          })            
      },
      remove_company(id){
            this.$confirm('删除入驻企业', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$store.commit('setLoading', {text:'正在移除..'});
                this.$http.post('/v1/pri/logistics-cfg/remove-company', {id:id})
                    .then( (response) => {
                        this.$store.commit('setLoading', {text:false});
                        var res = response.data;
                        if (res.code == 1) {
                            this.$message({
                                message: '移除成功',
                                type: 'success'
                            });
                            this.get_company_list()
                        } else {
                            this.$message({
                                message: res.msg,
                                type: 'warning'
                            });
                        }
                    })
                    .catch( (error) => {
                        this.$store.commit('setLoading', {text:false});
                    }) 
            }) 
      },
      remove_account(id){
          this.$confirm('删除制单账号', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
          }).then(() => {
              this.$store.commit('setLoading', {text:'正在移除..'});
              this.$http.post('/v1/pri/logistics-cfg/remove-company-account', {id:id})
                  .then( (response) => {
                      this.$store.commit('setLoading', {text:false});
                      var res = response.data;
                      if (res.code == 1) {
                          this.$message({
                              message: '移除成功',
                              type: 'success'
                          });
                          this.get_company_list()
                      } else {
                          this.$message({
                              message: res.msg,
                              type: 'warning'
                          });
                      }
                  })
                  .catch( (error) => {
                      this.$store.commit('setLoading', {text:false});
                  }) 
          }) 
      },
    },
    mounted(){
        this.get_company_list()
    },
}
</script>


// WEBPACK FOOTER //
// src/pages/logistics/setting/_list_company.vue